import styled from "styled-components";

import { FlexDiv } from "@/components/Atoms/Box";
import Typography from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";

export const FormBox = styled.form`
  padding: 0 16px;
`;

export const PersonalDetails = styled(Typography)`
  color: ${theme.colorsV2.purple.shade_900};
  font-size: 16px;
  line-height: 24px;
  padding: 8px 0;
  margin: 16px 0;
`;

export const ButtonWrapper = styled(FlexDiv)`
  justify-content: space-between;
  align-items: center;
  background-color: ${theme.colorsV2.blueGray.shade_50};
  padding: 16px 24px;
  border-radius: 16px;

  @media only screen and (max-width: 400px) {
    padding: 16px;
  }
`;

export const AmountWrapper = styled(FlexDiv)`
  align-items: flex-end;
  gap: 4px;
`;

export const Currency = styled(Typography)`
  color: ${theme.colorsV2.blueGray.shade_800};
  font-size: 14px;
  line-height: 19px;
  font-family: var(--man-700);
`;

export const Amount = styled(Typography)`
  color: ${theme.colorsV2.shyft.purple_text};
  font-size: 32px;
  line-height: 32px;
  font-family: var(--man-700);

  @media only screen and (max-width: 600px) {
    font-size: 24px;
    line-height: 28px;
    letter-spacing: -4%;
  }
`;

export const CallbackRequestText = styled(Typography)`
  font-family: var(--man-500);
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.4px;
  text-align:center;
  margin-top:32px;
  color:${theme.colorsV2.gray.shade_800}
  ::span{
    color:#0000EE
  }
`;

export const CallbackRequestLinkText = styled(Typography)`
  font-family: var(--man-500);
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.4px;
  text-align: center;
  color: #0000ee;
  cursor: pointer;
`;
